import React from 'react';

const Hero = () => {
  return (
    <section className="min-h-screen flex items-center justify-center">
      <h1 className="text-2xl font-bold">Relentless...</h1>
    </section>
  );
};

export default Hero;